import { rei } from "@/services/api"

class CpfGenerateService {
  static startSigning (registroId, certificate) {
    const data = {
      certificate: certificate
    }

    return rei.post(`cpf-generate/init/${registroId}`, data).then(res => res.data)
  }

  static endSigning (registroId, bryNonce, certificate, documents, signatures) {
    const data = {
      bryNonce: bryNonce.toString(),
      certificate: certificate,
      documents: documents,
      signatures: signatures
    }

    return rei.post(`cpf-generate/end/${registroId}`, data).then(res => res.data)
  }
}

export default CpfGenerateService
